const BarGraph = () => {
    return (
        <>
                <div className="col-md-6 col-lg-4 mb-4">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="card-title m-0 me-2">Performance</h5>
                            <div className="dropdown">
                                <button className="btn p-0" type="button" id="performanceId" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="bx bx-dots-vertical-rounded" />
                                </button>
                                <div className="dropdown-menu dropdown-menu-end" aria-labelledby="performanceId">
                                    <a className="dropdown-item" href="javascript:void(0);">Last 28 Days</a>
                                    <a className="dropdown-item" href="javascript:void(0);">Last Month</a>
                                    <a className="dropdown-item" href="javascript:void(0);">Last Year</a>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-6">
                                    <small>Earnings: <span className="fw-medium">$846.17</span></small>
                                </div>
                                <div className="col-6">
                                    <small>Sales: <span className="fw-medium">25.7M</span></small>
                                </div>
                            </div>
                        </div>
                        <div id="performanceChart" />
                    </div>
                </div>


                <div className="col-md-6 col-lg-4 mb-4">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <div className="card-title mb-0">
                                <h5 className="m-0 me-2">Conversion Rate</h5>
                                <small className="text-muted">Compared To Last Month</small>
                            </div>
                            <div className="dropdown">
                                <button className="btn p-0" type="button" id="conversionRate" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="bx bx-dots-vertical-rounded" />
                                </button>
                                <div className="dropdown-menu dropdown-menu-end" aria-labelledby="conversionRate">
                                    <a className="dropdown-item" href="javascript:void(0);">Select All</a>
                                    <a className="dropdown-item" href="javascript:void(0);">Refresh</a>
                                    <a className="dropdown-item" href="javascript:void(0);">Share</a>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex flex-row align-items-center gap-1 mb-4">
                                    <h2 className="mb-2">8.72%</h2>
                                    <small className="text-success fw-medium">
                                        <i className="bx bx-chevron-up" />
                                        4.8%
                                    </small>
                                </div>
                                <div id="conversionRateChart" />
                            </div>
                            <ul className="p-0 m-0">
                                <li className="d-flex mb-4">
                                    <div className="d-flex w-100 flex-wrap justify-content-between gap-2">
                                        <div className="me-2">
                                            <h6 className="mb-0">Impressions</h6>
                                            <small className="text-muted">12.4k Visits</small>
                                        </div>
                                        <div className="user-progress">
                                            <i className="bx bx-up-arrow-alt text-success me-2" /> <span>12.8%</span>
                                        </div>
                                    </div>
                                </li>
                                <li className="d-flex mb-4">
                                    <div className="d-flex w-100 flex-wrap justify-content-between gap-2">
                                        <div className="me-2">
                                            <h6 className="mb-0">Added To Cart</h6>
                                            <small className="text-muted">32 Product in cart</small>
                                        </div>
                                        <div className="user-progress">
                                            <i className="bx bx-down-arrow-alt text-danger me-2" /> <span>- 8.5% </span>
                                        </div>
                                    </div>
                                </li>
                                <li className="d-flex mb-4">
                                    <div className="d-flex w-100 flex-wrap justify-content-between gap-2">
                                        <div className="me-2">
                                            <h6 className="mb-0">Checkout</h6>
                                            <small className="text-muted">21 Products checkout</small>
                                        </div>
                                        <div className="user-progress">
                                            <i className="bx bx-up-arrow-alt text-success me-2" /> <span>9.12%</span>
                                        </div>
                                    </div>
                                </li>
                                <li className="d-flex">
                                    <div className="d-flex w-100 flex-wrap justify-content-between gap-2">
                                        <div className="me-2">
                                            <h6 className="mb-0">Purchased</h6>
                                            <small className="text-muted">12 Orders</small>
                                        </div>
                                        <div className="user-progress">
                                            <i className="bx bx-up-arrow-alt text-success me-2" /> <span>2.83%</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 col-lg-4">
                    <div className="row">
                        <div className="col-12 col-sm-6 col-md-3 col-lg-6 mb-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-title d-flex align-items-start justify-content-between">
                                        <div className="avatar flex-shrink-0">
                                            <img src="../../iusevolutione/assets/img/icons/unicons/cc-warning.png" alt="Credit Card" className="rounded" />
                                        </div>
                                        <div className="dropdown">
                                            <button className="btn p-0" type="button" id="cardOpt5" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i className="bx bx-dots-vertical-rounded" />
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-end" aria-labelledby="cardOpt5">
                                                <a className="dropdown-item" href="javascript:void(0);">View More</a>
                                                <a className="dropdown-item" href="javascript:void(0);">Delete</a>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="d-block mb-1">Revenue</span>
                                    <h3 className="card-title text-nowrap mb-2">$42,389</h3>
                                    <small className="text-success fw-medium"><i className="bx bx-up-arrow-alt" /> +52.18%</small>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-3 col-lg-6 mb-4">
                            <div className="card">
                                <div className="card-body">
                                    <span className="d-block fw-medium">Sales</span>
                                    <h3 className="card-title mb-2">482k</h3>
                                    <span className="badge bg-label-info mb-3">+34%</span>
                                    <small className="text-muted d-block">Sales Target</small>
                                    <div className="d-flex align-items-center">
                                        <div className="progress w-75 me-2" style={{ height: 8 }}>
                                            <div className="progress-bar bg-info" style={{ width: '78%' }} role="progressbar" aria-valuenow={78} aria-valuemin={0} aria-valuemax={100} />
                                        </div>
                                        <span>78%</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-12 mb-4">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between gap-3">
                                        <div className="d-flex align-items-start flex-column justify-content-between">
                                            <div className="card-title">
                                                <h5 className="mb-0">Expenses</h5>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <div className="mt-auto">
                                                    <h3 className="mb-2">$84.7k</h3>
                                                    <small className="text-danger text-nowrap fw-medium"><i className="bx bx-down-arrow-alt" /> 8.2%</small>
                                                </div>
                                            </div>
                                            <span className="badge bg-label-secondary rounded-pill">2021 Year</span>
                                        </div>
                                        <div id="expensesBarChart" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


        </>
    );
}

export default BarGraph;